var React = require('react');

function PillInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.9326 3.08966C26.943 1.10345 24.2902 0 21.5268 0C18.7634 0 16.1105 1.10345 14.1209 3.08966L3.06736 14.1241C-1.02245 18.2069 -1.02245 24.8276 3.06736 28.9103C5.05699 30.8966 7.70984 32 10.4732 32C13.2366 32 15.8895 30.8966 17.8791 28.9103L28.9326 17.8759C33.0225 13.7931 33.0225 7.17241 28.9326 3.08966ZM16.3316 27.3655C14.7841 28.9103 12.6839 29.7931 10.4732 29.7931C8.26252 29.7931 6.16235 28.9103 4.61485 27.3655C1.40933 24.1655 1.40933 18.869 4.61485 15.669L9.36788 10.9241L21.0846 22.6207L16.3316 27.3655Z","fill":"currentColor"}));
}

PillInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = PillInline;

PillInline.default = PillInline;
